import { useState } from 'react';
import { Link } from 'react-router';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';

const BarcodeScanner = () => {
  const [data, setData] = useState('No barcode detected');
  // const [scanHistory, setScanHistory] = useState([]);
  const [items, setItems] = useState([]);
  const beepSound = new Audio('/beep.mp3');

  const handleUpdate = (itemName) => {
    setItems((prevPd) => {
      // Check if the item exists
      const itemIndex = prevPd.findIndex((obj) => obj.item === itemName);

      if (itemIndex !== -1) {
        // If it exists, increment qty
        return prevPd.map((obj, index) =>
          index === itemIndex ? { ...obj, qty: obj.qty + 1 } : obj
        );
      } else {
        // If it doesn't exist, add it
        return [...prevPd, { item: itemName, qty: 1 }];
      }
    });
  };


  return (
    <div className="flex flex-col items-center justify-center p-4">
      <h1>Barcode/QRcode Scanner</h1>
      <BarcodeScannerComponent
        width={250}
        height={250}
        delay = {1000}
        onUpdate={(err, result) => {
          if (result) {
            beepSound.play();
            setData(result.text);
            // setScanHistory(prevHistory => [...prevHistory, result.text]);
            handleUpdate(result.text);
          }
          else setData('No barcode detected');
        }}
        onError={(error) => {
          // console.log(error,error.message);
          setData(error.name + " : "+ error.message);
        }}
      />
      <p className={data==="No barcode detected" ? "mt-2 text-red-600 text-xs" : "mt-2 text-green-600 text-xs"}>{data}</p>
      <table className="text-xs">
        <thead>
          <tr>
            <th>No.</th>
            <th>Item</th>
            <th>Qty</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item,i) => (
            <tr key={i} className="odd:bg-slate-100">
              <td className="border p-1">{i+1}.</td>
              <td className="border p-1">{item.item}</td>
              <td className="border text-right p-1">{item.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* <ol className="list-decimal">
          {scanHistory.map((result, index) => (
              <li key={index} className=" text-xs">{result}</li>
          ))}
      </ol> */}
      <div type="button" className="mt-10 p-2 rounded-full text-sm text-white bg-blue-800 hover:bg-blue-600">
        <Link to="/">
            Home...
        </Link>
      </div>

    </div>
  );
};

export default BarcodeScanner;
